import { combineActions, handleActions } from 'redux-actions'
import { combineReducers } from 'redux'
import { defaultSettings, customLinkDefault } from './model'

import * as actions from './actions'

const settings = handleActions({
  [actions.fetchSettingsSuccess]: (state, action) => ({...state, ...action.payload}),
  [actions.fetchCustomLinksSuccess]: (state, action) => ({...state, customLinks: action.payload }),
  [actions.setCnameDomain]: (state, action) => Object.assign({}, state, { cnameDomain: action.payload }),
  [actions.setGoogleAnalyticsCode]: (state, action) => Object.assign({}, state, { googleAnalyticsCode: action.payload }),
  [actions.setDriftHelpDomain]: (state, action) => Object.assign({}, state, { driftHelpDomain: action.payload }),
  [actions.appendToDomain]: (state, action) => Object.assign({}, state, { driftHelpDomain: `${state.driftHelpDomain}${action.payload}`}), // Todo: This code is horrible and needs to be changed as soon as we have designs in place. This is the quickest fix to ensure users to mess up their domain names. It's gotta end with drift.help, just gotta
  [actions.setTitle]: (state, action) => Object.assign({}, state, { title: action.payload }),
  [actions.setDescription]: (state, action) => Object.assign({}, state, { description: action.payload }),
  [actions.setTagline]: (state, action) => Object.assign({}, state, { tagline: action.payload }),
  [actions.setFavicon]: (state, action) => Object.assign({}, state, { favicon: action.payload }),
  [actions.setLogo]: (state, action) => Object.assign({}, state, { logo: action.payload }),
  [actions.setColor]: (state, action) => Object.assign({}, state, { mainColor: action.payload }),
  [actions.updateKBNoIndex]: (state, action) => Object.assign({}, state, { isKBIndexed: action.payload }),
  [actions.changeCustomLinkUrl]: (state, action) => ({...state, selectedCustomLink: { ...state.selectedCustomLink, url: action.payload }}),
  [actions.changeCustomLinkText]: (state, action) => ({...state, selectedCustomLink: {...state.selectedCustomLink, displayText: action.payload }}),
  [actions.setSelectedCustomLink]: (state, action) => ({...state, selectedCustomLink: action.payload }),
  [actions.saveCustomLinkSuccess]: (state, action) => ({...state, customLinks: action.payload }),
  [actions.editCustomLinkSuccess]: (state, action) => ({...state, customLinks: action.payload }),
  [actions.deleteCustomLinkSuccess]: (state, action) => ({...state, customLinks: action.payload }),
  [actions.clearCustomLink]: (state, action) => ({...state, selectedCustomLink: customLinkDefault})
}, defaultSettings)

const changed = handleActions({
  [combineActions(
    actions.setCnameDomain,
    actions.setGoogleAnalyticsCode,
    actions.setDriftHelpDomain,
    actions.setTitle,
    actions.setDescription,
    actions.setTagline,
    actions.setFavicon,
    actions.setLogo,
    actions.setColor,
    actions.updateKBNoIndex
  )]: () => true,
  [combineActions(
    actions.updateSettingsSuccess,
  )]: () => false,
}, false)

const updateSettingsStatus = handleActions({
  [combineActions(
    actions.updateSettings,
    actions.updateSettingsPending,
    actions.updateSettingsFailed,
    actions.updateSettingsSuccess,
  )]: (state, action) => action.type,
}, false)

const botConfig = handleActions({
  [actions.fetchBotConfigSuccess]: (state, action) => ({...action.payload}),
  [actions.setBotConfig]: (state, action) => ({...action.payload, enabled: action.payload.enabled })
}, {enabled: false, botDataSource: ''})

const syncedKnowledgebaseList = handleActions({
  [actions.fetchSyncedKnowledgebaseListSuccess]: (state, action) => action.payload
}, [])

export default combineReducers({
  settings,
  changed,
  updateSettingsStatus,
  botConfig,
  syncedKnowledgebaseList
})
